// ✅ US Market Web Application Development - Thin Wrapper (DRY principle)
import WebAppDevelopmentPage from '../web-application-development';
import SEOHead from '../../components/SEOHead';

export default function USWebAppDevelopment() {
  return (
    <>
      <SEOHead
        title='Web Application Development | US Market | LBVisible'
        description='Custom web application development services for US businesses.'
        keywords='web app development USA, custom web applications USA, SaaS development'
        canonicalUrl='/us/web-application-development'
        lang='en'
        hreflang={[
          { hreflang: 'en-GB', href: 'https://www.lbvisible.com/web-application-development' },
          { hreflang: 'en-US', href: 'https://www.lbvisible.com/us/web-application-development' },
          { hreflang: 'lt-LT', href: 'https://www.lbvisible.com/lt/aplikaciju-programavimas' },
          { hreflang: 'x-default', href: 'https://www.lbvisible.com/web-application-development' },
        ]}
      />

      <WebAppDevelopmentPage />
    </>
  );
}
